import { render, staticRenderFns } from "./OrderConfirmation-Content.vue?vue&type=template&id=d5734d3c&"
import script from "./OrderConfirmation-Content.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmation-Content.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmation-Content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports